import { mat4 } from "pex-math";

function createDrawTrunkCmd(ctx) {
  /*
  const noiseTexture = ctx.texture2D({
    width: 256,
    height: 256,
  });
  */
  const drawTrunkCmd = {
    name: "drawRegularCmd",
    pipeline: ctx.pipeline({
      vert: /*glsl*/ `
      attribute vec3 aPosition;
      // attribute vec3 aNormal;
      // attribute vec2 aTexCoord0;
        
      uniform mat4 uProjectionMatrix;
      uniform mat4 uViewMatrix;
      uniform mat4 uModelMatrix;

      // varying vec3 vNormalView;      
      varying vec2 vTexCoord;

      void main () {       
        // vTexCoord = aTexCoord0;
        // vTexCoord = vec2(0.0);

        vec4 positionWorld = uModelMatrix * vec4(aPosition, 1.0);
        vTexCoord = positionWorld.xy / 6.5 * 0.5 + 0.5;
        
        // vNormalView = vec3(uViewMatrix * uModelMatrix * vec4(aNormal, 0.0));
        gl_Position = uProjectionMatrix * uViewMatrix * positionWorld;      
      }
      `,
      frag: /*glsl*/ `
      precision highp float;           
      // varying vec3 vNormalView;      
      varying vec2 vTexCoord;
        
      uniform vec4 uBaseColor;
      uniform sampler2D uTexture;
      uniform bool uGammaOutput;
      uniform sampler2D uDirtTexture;
      uniform sampler2D uNoiseTexture;
      uniform float uReveal;
      uniform bool uGreyscale;
      

      vec3 grayscale(vec3 color) {
        float g = dot(color.rgb, vec3(0.299, 0.587, 0.114));
        return vec3(g);
      }

      //   
      void main () {
        gl_FragData[0] = vec4(vTexCoord, 0.0, 1.0);
        vec3 texColor = (pow(texture2D(uTexture, vTexCoord).rgb, vec3(2.2)));
        vec3 dirtColor = (texture2D(uDirtTexture, vTexCoord).rgb);
        if (uGreyscale) {
          texColor = grayscale(texColor);
          dirtColor = grayscale(dirtColor);
        }
        vec3 albedoColor = pow(uBaseColor.rgb, vec3(2.2));        
        vec3 color = albedoColor * texColor * dirtColor;
        vec3 noiseColor = texture2D(uNoiseTexture, vTexCoord).rgb;
        if (noiseColor.r > uReveal) discard;

        color = pow(color, vec3(1.0 / 2.2));
        
        gl_FragData[0] = vec4(color, 1.0);
        // gl_FragData[0].rgb *= 1.5;
        // if (uGammaOutput) {
        //   gl_FragData[0].rgb = pow(gl_FragData[0].rgb, vec3(1.0 / 2.2));
        // }
      }
      `,
      depthTest: true,
      depthWrite: true,
    }),
    attributes: {
      aPosition: null,
    },
    indices: null,
  };

  const modelMatrix = mat4.create();

  return function drawTrunk({
    ctx,
    camera,
    mesh,
    noiseTexture,
    texture,
    dirtTexture,
    reveal,
    baseColor,
  }) {
    drawTrunkCmd.attributes.aPosition = mesh.positions.buffer;
    drawTrunkCmd.indices = mesh.indices.buffer;

    if (!noiseTexture.width || !baseColor) return;

    ctx.submit(drawTrunkCmd, {
      uniforms: {
        uBaseColor: baseColor,
        uProjectionMatrix: camera.projectionMatrix,
        uViewMatrix: camera.viewMatrix,
        uGammaOutput: true,
        uNoiseTexture: noiseTexture,
        uTexture: texture,
        uDirtTexture: dirtTexture,
        uReveal: reveal,
        uGreyscale: true,
        uModelMatrix: modelMatrix,
      },
    });
  };
}

export default createDrawTrunkCmd;
